import React, { Component } from 'react'
import E from 'wangeditor'
import axios from '../../service/index'
import { message, Button, Divider } from 'antd'
import "./aboutus.less"
const qiniuUpUrl = 'https://up-z1.qiniup.com'
class Aboutus extends Component {
	constructor(props){
		super(props)
		this.state = {
			editor: '',
			token: '',
			url: ''
		}
	}
	gotoHome() {
		this.props.history.push('/home')
	}
	getToken() {
		let _this = this;
		axios.get("uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	componentDidMount() {
		this.getToken()
		this.getAboutus()
		let editor = new E("#div1")
		this.setState({editor: editor})
		editor.config.menus = [
			'head',
			'bold',
			'fontSize',
			'fontName',
			'italic',
			'underline',
			'strikeThrough',
			'indent',
			'lineHeight',
			'foreColor',
			'backColor',
			'link',
			'list',
			'todo',
			'justify',
			'quote',
			'table',
			'splitLine',
			'undo',
			'redo',
			'image',
	   ]
	   	editor.config.uploadImgMaxLength = 5;
	  	editor.config.showLinkImg = false;
	   	editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
	  	editor.config.withCredentials = false;
	   	editor.config.uploadImgTimeout = 5 * 1000;
	   // editor.customConfig.zIndex = 100;
	   let _this = this
	   editor.config.customUploadImg = function (resultFiles, insertImgFn) {
		   let imgUrl = ''
		   let data = new FormData();
		   data.append("token", _this.state.token);
		   data.append("file", resultFiles[0]);
		   axios({
			   method: "POST",
			   url: qiniuUpUrl,
			   data: data,
			   onUploadProgress: function (progressEvent) {
				//    var percentCompleted = Math.round(
				// 	   (progressEvent.loaded * 100) /
				// 	   progressEvent.total
				//    );
			   },
		   }).then((res) => {
			   console.log(res)
			   imgUrl = _this.state.url +'/'+ res.data.key
			   insertImgFn(imgUrl);
		   });
	   };
	   editor.create()
	}
	async getAboutus(){
		axios.post('aboutController/info').then( res => {
			if(res.data.code === '200') {
				this.state.editor.txt.html(res.data.data.content)
			}else {
				message.error(res.data.msg)
			}
		})
	}
	aboutUpdata() {
		axios.post('/aboutController/update',{
			content: this.state.editor.txt.html()
		}).then(res=> {
			if(res.data.code === '200') {
				message.success('发布成功')
			}else {
				message.error(res.data.msg)
			}
		})
	}
    render() {
        return (
            <div className="editor">
				<span style={{display: 'flex', alignItems: 'center',fontSize: '18px',fontWeight: '600'}}>关于我们</span>
				<Divider />
                <div className="editor-height" id='div1'></div>
				<div style={{display:'flex',justifyContent:'center',marginTop: '30px'}}>
					<Button className="ant-btn-primary" onClick={()=>{
						this.aboutUpdata()
					}}>&nbsp;发&nbsp;&nbsp;&nbsp;&nbsp;布&nbsp;</Button>
				</div>
				
            </div>
        )
    }
}

export default Aboutus